import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Program {
  _id: string;
  name: string;
  description?: string;
  status: "active" | "inactive";
  parentDepartmentId?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type ProgramPayload = {
  name: string;
  description?: string;
  status: "active" | "inactive";
  parentDepartmentId?: string;
  members?: string[];
  timezone?: string;
};

export type ProgramResponse = {
  success: boolean;
  message: string;
  data: Program;
};

const addProgram = async (
  payload: ProgramPayload
): Promise<ProgramResponse> => {
  const { data } = await customAxios.post<ProgramResponse>(
    "/programs/program",
    payload
  );
  return data;
};

export const useAddProgram = () => {
  const queryClient = useQueryClient();

  return useMutation<ProgramResponse, AxiosError, ProgramPayload>({
    mutationFn: addProgram,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["programs"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to add program",
        color: "red",
      }),
  });
};
